module.exports = __webpack_public_path__ + "static/media/map01.883751ee.png";